import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Model } from "@/components/Model";
import { Services } from "@/components/Services";
import { WhoWeHelp } from "@/components/WhoWeHelp";
import { HowItWorks } from "@/components/HowItWorks";
import { Manifesto } from "@/components/Manifesto";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { Journal } from "@/components/Journal";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";

export default function Home() {
  const lenisRef = useRef(null);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [therapist, setTherapist] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    if (lenisRef.current) lenisRef.current.scrollTo(`#${id}`, { offset: -72, duration: 1.4 });
  };

  const openBooking = (t = "") => {
    setTherapist(t);
    setBookingOpen(true);
  };

  return (
    <div className="grain min-h-screen bg-cream text-pine-900" data-testid="home-page">
      <Navbar onBook={() => openBooking()} onNavigate={scrollTo} />
      <main>
        <Hero onBook={() => openBooking()} onNavigate={scrollTo} />
        <Marquee />
        <Model />
        <Services onBook={() => openBooking()} />
        <WhoWeHelp />
        <HowItWorks />
        <Manifesto />
        <Team onBook={openBooking} />
        <Testimonials />
        <Journal />
        <Faq />
        <Contact onBook={() => openBooking()} />
      </main>
      <Footer onNavigate={scrollTo} />
      <BookingModal
        open={bookingOpen}
        onClose={() => setBookingOpen(false)}
        therapist={therapist}
      />
    </div>
  );
}
